import { render, staticRenderFns } from "./LenovoDownload.vue?vue&type=template&id=6b0f7396&"
import script from "./LenovoDownload.vue?vue&type=script&lang=js&"
export * from "./LenovoDownload.vue?vue&type=script&lang=js&"
import style0 from "./LenovoDownload.vue?vue&type=style&index=0&id=6b0f7396&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports